interface PageHeaderProps {
  title: string;
  description?: string;
}

export function PageHeader({ title, description }: PageHeaderProps) {
  return (
    <div className="pb-[8px]">
      <h1 className="font-manrope font-bold text-[32px] leading-[32px] text-[color:var(--black-text,#0d0d0d)] mb-[8px]">
        {title}
      </h1>
      {description && (
        <p className="font-segoe text-[16px] leading-[24px] text-[color:var(--grey-text,#565858)] max-w-[650px] whitespace-pre-line">
          {description}
        </p>
      )}
    </div>
  );
}
